export default "__VITE_ASSET__CLiExT80__"